import { render, staticRenderFns } from "./PreviewPortfolio.vue?vue&type=template&id=12cbc21e&lang=pug"
import script from "./PreviewPortfolio.vue?vue&type=script&lang=js"
export * from "./PreviewPortfolio.vue?vue&type=script&lang=js"
import style0 from "./PreviewPortfolio.vue?vue&type=style&index=0&id=12cbc21e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports